// GET Requests

// export const USERS_EMAIL_AVAILABLE = `/users/email-available`;
export const USERS_FETCH = `/users/fetch`;
export const LOCATIONS_FETCH = `/stores/locations`;
export const ASSOCIATES_FETCH = `/stores/associates`;
export const DIAMONDS_FETCH = `/diamonds/filter`;
export const DIAMONDS_FETCH_SINGLE = `/diamonds/single`;
export const MESSAGES_FETCH = `/messages/fetch`;
export const MESSAGES_DELETED_FETCH = `/messages/deleted`;
export const MESSAGES_SENT = `/messages/sent`;
export const USERS_FETCH_DIRECTORY = `/users/directory`;
export const USERS_FETCH_SELF = `/users/self`;
export const LEADS_FETCH = `/users/leads`;
export const USERS_FETCH_FULL_CARD = `/users/card/full`;
export const USERS_FETCH_CUSTOMER_CARD = `/users/card/external`;
export const USERS_FETCH_CARD_DIRECTORY = `/users/card/directory`;
export const LEADS_SHARE_EXTERNAL = `/users/share/external`;
export const LEADS_SHARE_EXTERNAL_WATCH = `/users/share/watch-external`;
export const LEADS_CREATE_EXTERNAL = `/users/create/external`;
export const LEADS_CREATE_EXTERNAL_WATCH = `/users/create/watch-external`;
export const LEADS_FETCH_EXTERNAL_SHARE = `/users/share/fetch`;
export const USERS_FETCH_SOCIAL_SHARE = `/users/card/share`;
export const USERS_ADMIN_PASSWORD_RESET = `/users/admin/reset-password`;
export const DIAMONDS_LOCATION_DATA = `/diamonds/locations`;
export const LEADS_DELETE_CARD = `/users/card/delete`;
export const LEADS_SEND_CARD = `/users/card/send`;
export const NOTES_FETCH = `/users/notes/fetch`;
export const USERS_CARD_DIAMONDS_FETCH = `/users/card/diamonds/fetch`;

export const USERS_DD_AUTH = `/users/ms/auth`;
export const USERS_DD_SET_QUESTION = `/users/challenge`;
export const USERS_DD_CHECK_QUESTION = `/users/challenge`;
export const USERS_LOCAL_AUTH = `/users/local/auth`;

// POST Requests
export const USERS_FORGOT_PASSWORD = `/users/forgot-password`;
export const USERS_LOGIN = `/users/login`;
export const USERS_RESET_PASSWORD = `/users/reset-password`;
export const USERS_INTERNAL_RESET_PASSWORD = `/users/internal-password`;
export const USERS_CARD_ADD_DIAMONDS = `/users/card/diamonds/add`;
export const USERS_CARD_REMOVE_DIAMONDS = `/users/card/diamonds/remove`
export const USERS_DELETE = `/users/delete`;
export const USERS_SAVE = `/users/save`;
export const USERS_SAVE_CARD = `/users/customer-card`;
export const USERS_VALIDATE_PASSWORD = `/users/validate`;

export const MESSAGES_SEND_SIMPLE = `/messages/send/simple`;
export const MESSAGES_SEND_SHARE = `/messages/send/share`;
export const MESSAGES_SEND_HOLD = `/messages/send/hold`;
export const MESSAGES_SEND_TRANSFER = `/messages/send/transfer`;
export const MESSAGES_SEND_TRANSFER_LOC50 = `/messages/send/sold-online`;
export const MESSAGES_RECORD_READ = `/messages/read`;
export const MESSAGES_DELETE = `/messages/delete`;
export const MESSAGES_DELETE_ALL = `/messages/delete-all`;

export const MESSAGES_APPROVE_TRANSFER = `/messages/transfer/confirm`;
export const MESSAGES_REJECT_TRANSFER = `/messages/transfer/reject`;
export const MESSAGES_APPROVE_HOLD = `/messages/hold/confirm`;
export const MESSAGES_REJECT_HOLD = `/messages/hold/reject`;

export const MESSAGES_TRANSFERS_MINE = `/messages/transfers/me`;

export const LEADS_EXPORT = `/users/card/export`;

export const NOTES_CREATE = `/users/notes/create`;
export const NOTES_EDIT = `/users/notes/edit`;
export const NOTES_DELETE = `/users/notes/delete`;


// Finance endpoints

export const FINANCE_FETCH_PLANS = `/finance/plans`;
export const FINANCE_CREATE_PLAN = `/finance/plans`;
export const FINANCE_EDIT_PLAN = `/finance/plans/manage`;
export const FINANCE_DELETE_PLAN = `/finance/plans/manage`;


// Customer service endpoints

// export const USERS_CUSTOMER_FETCH_BY_NUMBER = `/apis/customer-service/v1/customer/`;
// export const USERS_CUSTOMERS_UPDATE = `/apis/customer-service/v1/customer/`;
// export const USERS_CUSTOMERS_SEARCH = `/apis/customer-service/v1/customers`;
export const USERS_CUSTOMER_FETCH_BY_EMAIL = `/api/customers/by-email`;
export const USERS_CUSTOMER_FETCH_BY_NUMBER = `/api/customers/by-id`;
export const USERS_CUSTOMERS_CREATE = `/api/customers/`;
export const USERS_CUSTOMERS_UPDATE = `/api/customers/`;
export const USERS_CUSTOMERS_NOTES = `/api/customers/notes`;
export const USERS_CUSTOMERS_NOTES_ADD = `/api/customers/notes/add`;
export const USERS_CUSTOMERS_SEARCH = `/api/customers/search`;
export const USERS_CUSTOMERS_AUTOCOMPLETE = `/api/customers/autocomplete`;


// Product service endpoints

export const PRODUCT_WATCH_FETCH_LIST = `/api/watches/filter`;
export const PRODUCT_WATCH_FETCH_BY_SKU = `/api/watches/sku`;

export const PRODUCT_WATCH_FETCH_GENERATE_POST = `/api/watches/{{sku}}/media/{{filename}}`;
export const PRODUCT_WATCH_FETCH_UPDATE_IMAGE = `/api/watches/image`;
export const PRODUCT_WATCH_FETCH_DELETE_IMAGE = `/api/watches/image`;

export const PRODUCT_JEWELRY_FETCH_LIST = `/api/products/gallery`;
export const PRODUCT_JEWELRY_FETCH_BY_ASCID = '/apis/product-service/v1/asc-jewelry';
export const PRODUCT_JEWELRY_FETCH_BY_BARCODE_ID = '/apis/product-service/v1/asc-jewelry/barcode/';


// DD Online service endpoints

// export const DD_ONLINE_DIAMONDS = `/api/dd2diamond`;
export const DD_ONLINE_DIAMONDS = `/apis/product-service/v1/dd-app/list-diamonds`;
export const DD_ONLINE_DIAMOND_BY_ID = `/api/diamond/find_by_id`;


// Rapnet service endpoints

export const RAPNET_DIAMONDS = `/HTTP/JSON/RetailFeed/GetDiamonds.aspx`;
export const RAPNET_DIAMOND_BY_ID = `/HTTP/JSON/RetailFeed/GetSingleDiamond.aspx`;
export const RAPNET_DIAMOND_PRICE_FULL = `https://technet.rapaport.com:449/HTTP/JSON/Prices/GetPrice.aspx`;





































